import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Qualification } from "./components/Qualification";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Scrollup } from "./components/Scrollup";
import { useTranslation, Trans } from 'react-i18next';

function App() {
  const { t, i18n } = useTranslation();
  return (
    <div className="App">
      <NavBar />
      <Banner />
      <Qualification />
      <Contact />
      <Skills />
      <Footer />
      <Scrollup />
    </div>
  );
}

export default App;
